/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class PromiseQueue {
    add(task) {
        return new Promise((resolve, reject)=>{
            this.queue.push(async ()=>{
                try {
                    const result = await task();
                    resolve(result);
                    return result;
                } catch (error) {
                    reject(error);
                    throw error;
                }
            });
            this.run();
        });
    }
    async run() {
        if (this.running >= this.concurrency || 0 === this.queue.length) return;
        this.running++;
        const task = this.queue.shift();
        try {
            const result = await task();
            this.results.push(result);
        } catch (error) {} finally{
            this.running--;
            this.run();
        }
    }
    async waitAll() {
        while(this.running > 0 || this.queue.length > 0)await new Promise((resolve)=>setTimeout(resolve, 100));
        return this.results;
    }
    constructor(concurrency = 1){
        _define_property(this, "queue", []);
        _define_property(this, "concurrency", void 0);
        _define_property(this, "running", 0);
        _define_property(this, "results", []);
        this.concurrency = concurrency;
    }
}
export { PromiseQueue };

//# sourceMappingURL=promise-queue.mjs.map